import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assests/Images";
import { useMutation, useQuery } from "react-query";
import { executiveData, ordersData } from "../globalApi/Api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { type } from "@testing-library/user-event/dist/type";
import PopupModel from "../popupmodel/PopupModel";
import downloadImage from "../../assests/download.png";
import DatePicker from "react-datepicker";
const SalesReport = () => {

    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const [selectedRows, setSelectedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [ismodelOpen, setIsmodelOpen] = useState(false);
    const [isIncentiveOpen, setIsIncentiveOpen] = useState(false);

    const selectedExecutive = watch("executiveName");
    const selectedRoute = watch("lineroute");
    const fromDate = watch("fromDate");
    const toDate = watch("toDate");

    const [popupType, setPopupType] = useState({
        type: "",
        data: "",
    });
    const [executiveRoute, setExecutiveRoute] = useState({
        execvutiveName: "",
        route: "",
    });
    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupType({
            type: "",
            data: "",
        });
    };

    // GET API START
    const { data, isLoading, isError, refetch } = useQuery(
        "ordersData",
        ordersData,
        {
            refetchOnWindowFocus: false,
        }
    );

    let details = (data && data?.data) || [];

    // GET API END

    // GET API START FOR EXECUTIVE
    const {
        data: executiveDetails,
        isLoading: executiveLoading,
        refetch: executiveRefetch,
    } = useQuery("executive", executiveData, {
        refetchOnWindowFocus: false,
    });

    // GET API END FOR EXECUTIVE

    const executives = executiveDetails?.data;

    const filteredDetails =
        details &&
        details
            ?.filter((item) => {
                const lowerSearch = searchTerm?.toLowerCase();

                const nameMatch = item?.executiveName
                    ?.toLowerCase()
                    .startsWith(lowerSearch);

                const idMatch = String(item?.customerName)
                    ?.toLowerCase()
                    .startsWith(lowerSearch);

                const executiveMatch =
                    !selectedExecutive || item?.executiveName === selectedExecutive;

                const routeMatch = !selectedRoute || item?.lineroute === selectedRoute;

                const itemDateStr = item?.salesDate
                    ? moment(item?.salesDate).format("YYYY-MM-DD")
                    : null;

                const fromDateStr = fromDate
                    ? moment(fromDate).format("YYYY-MM-DD")
                    : null;
                const toDateStr = toDate
                    ? moment(toDate).format("YYYY-MM-DD")
                    : null;

                const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
                const toDateMatch = !toDateStr || itemDateStr <= toDateStr;

                const dateMatch = fromDateMatch && toDateMatch;

                return (
                    (nameMatch || idMatch) &&
                    executiveMatch &&
                    routeMatch &&
                    dateMatch
                );
            })
            ?.sort((a, b) =>
                new Date(a.salesDate) - new Date(b.salesDate)
            );


    // DashboadDetails
    let overallOrdes = filteredDetails && filteredDetails?.length;
    const processingCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "processing"
        ).length;
    const CanceledCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "canceled"
        ).length;
    const returnedCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "return"
        ).length;
    const deliveredCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.deliveryStatus?.toLowerCase() === "delivered"
        ).length;



    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelectedRows) => {
            const isSelected = prevSelectedRows?.includes(id);
            if (isSelected) {
                return prevSelectedRows?.filter((rowId) => rowId !== id);
            } else {
                return [...prevSelectedRows, id];
            }
        });
    };

    // SELECT ALL IMAGE
    const allRowIds = filteredDetails?.map((data) => data?.id);

    const isAllSelected =
        allRowIds?.length > 0 && selectedRows?.length === allRowIds?.length;

    const handleSelectAll = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(allRowIds);
        }
    };
    // SELECT END
    useEffect(() => {
        setExecutiveRoute({
            ...executiveRoute,
            execvutiveName: selectedExecutive,
            route: selectedRoute,
        });
    }, [selectedExecutive, selectedRoute]);
    return (
        <>
            <div className="view_form_block">
                <div className="view_form_sub_block">
                    {/* DASHBOARD */}
                    <div className="row my-3 d-flex justify-content-center">
                        <div className="col-12 col-sm-6 col-lg-2 dashborad-card-block --first-block">
                            <span className="dashboard-heading" style={{ color: "#4B5563" }}>
                                Overall
                            </span>
                            <span className="dashboard-value">{overallOrdes || 0}</span>
                        </div>
                        <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading" style={{ color: "#92400E" }}>
                                Processing
                            </span>
                            <span className="dashboard-value">{processingCount || 0}</span>
                        </div>
                        <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading" style={{ color: "#7F1D1D" }}>
                                Canceled
                            </span>
                            <span className="dashboard-value">{CanceledCount || 0}</span>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading" style={{ color: "#1E40AF" }}>
                                Return
                            </span>
                            <span className="dashboard-value">{returnedCount || 0}</span>
                        </div>

                        <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block --last-block">
                            <span className="dashboard-heading" style={{ color: "#065F46" }}>
                                Delivered
                            </span>
                            <span className="dashboard-value">{deliveredCount || 0}</span>
                        </div>
                    </div>


                    {/* Filter and Search */}
                    <div className="row gx-2 gy-2 align-items-center">

                        {/* Search Input */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <input
                                type="search"
                                className="form-control"
                                placeholder="Search by customer name or executive"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        {/* Executive Dropdown */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <Controller
                                name="executiveName"
                                control={control}
                                render={({ field }) => (
                                    <select {...field} className="form-select">
                                        <option value="">All Executive</option>
                                        {executives?.map((data, index) => (
                                            <option key={index} value={data?.executiveName}>
                                                {`${data?.executiveName} : ${data?.phoneNumber}`}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            />
                        </div>

                        {/* Route Dropdown */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <Controller
                                name="lineroute"
                                control={control}
                                render={({ field }) => (
                                    <select {...field} className="form-select">
                                        <option value="">All Route</option>
                                        <option value="Route-I">Route-I</option>
                                        <option value="Route-II">Route-II</option>
                                        <option value="Route-III">Route-III</option>
                                    </select>
                                )}
                            />
                        </div>

                        {/* From Date */}
                        <div className="col-6 col-sm-6 col-md-3 col-lg-2">
                            <Controller
                                name="fromDate"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select From Date"
                                        maxDate={new Date()}
                                        className="form-control"
                                    />
                                )}
                            />
                        </div>

                        {/* To Date */}
                        <div className="col-6 col-sm-6 col-md-3 col-lg-2">
                            <Controller
                                name="toDate"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select To Date"
                                        minDate={fromDate}
                                        maxDate={new Date()}
                                        className="form-control filter-date-picker"
                                    />
                                )}
                            />
                        </div>

                        {/* Download Button */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <button
                                type="button"
                                className="btn btn-primary w-100"
                                onClick={() => setIsmodelOpen(true)}
                            >
                                DOWNLOAD
                            </button>
                        </div>

                    </div>


                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="view-table-heading">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        style={{
                                                            accentColor: "blue",
                                                            width: "18px",
                                                            height: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        checked={isAllSelected}
                                                        onChange={handleSelectAll}
                                                    />
                                                    SELECT
                                                </div>
                                            </th>
                                            <th className="view-table-heading">ORDER ID</th>
                                            <th className="view-table-heading">CUSTOMER</th>
                                            <th className="view-table-heading">EXECUTIVE</th>
                                            <th className="view-table-heading">ADDRESS</th>
                                            <th className="view-table-heading">LINE ROUTE</th>
                                            <th className="view-table-heading">ORDERED DATE</th>
                                            <th className="view-table-heading">DELIVERY STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <>
                                                <h5 className="my-3">L O A D I N G . . .</h5>
                                            </>
                                        ) : filteredDetails?.length > 0 ? (
                                            <>
                                                {filteredDetails?.map((data, i) => {
                                                    return (
                                                        <>
                                                            <tr
                                                                key={i}


                                                            >
                                                                <td
                                                                    className="view-table-data"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                >
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{
                                                                                accentColor: "blue",
                                                                                width: "18px",
                                                                                height: "18px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            checked={selectedRows?.includes(data?.id)}
                                                                            onChange={() =>
                                                                                handleCheckboxChange(data?.id)
                                                                            }
                                                                        />
                                                                        <div
                                                                            style={{ width: "20px", height: "20px" }}
                                                                            onClick={() => {
                                                                                navigate("/invoice", { state: data });
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={downloadImage}
                                                                                alt="no-image"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "contain",
                                                                                }}
                                                                                title="Download Invoice"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.orderId || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.customerName || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.executiveName || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.customerAddress || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.lineroute || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.salesDate
                                                                        ? moment(data?.salesDate).format(
                                                                            "DD-MM-YYYY"
                                                                        )
                                                                        : "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.deliveryStatus || "-"}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <h6>No Record Founds</h6>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PopupModel
                isOpen={ismodelOpen}
                closePopup={() => {
                    setIsmodelOpen(false);
                }}
                type="select report"
                filteredDetails={filteredDetails}
                allRowIds={allRowIds}
                executiveNameRoute={executiveRoute}
            />
        </>
    )
}

export default SalesReport